var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4987 9.99935C12.7999 9.99935 14.6654 8.13387 14.6654 5.83268C14.6654 3.5315 12.7999 1.66602 10.4987 1.66602C8.19751 1.66602 6.33203 3.5315 6.33203 5.83268C6.33203 8.13387 8.19751 9.99935 10.4987 9.99935Z",
    stroke: "#EDF2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33984 18.3333C3.33984 15.1083 6.54817 12.5 10.4982 12.5C11.2982 12.5 12.0732 12.6083 12.7982 12.8083",
    stroke: "#EDF2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8346 14.9993C18.8346 15.266 18.8013 15.5243 18.7346 15.7743C18.6596 16.1077 18.5263 16.4327 18.3513 16.716C17.7763 17.6827 16.718 18.3327 15.5013 18.3327C14.643 18.3327 13.868 18.0077 13.2846 17.4743C13.0346 17.2577 12.818 16.9993 12.6513 16.716C12.343 16.216 12.168 15.6243 12.168 14.9993C12.168 14.0993 12.5263 13.2744 13.1096 12.6744C13.718 12.0494 14.568 11.666 15.5013 11.666C16.4846 11.666 17.3763 12.091 17.9763 12.7744C18.5096 13.366 18.8346 14.1493 18.8346 14.9993Z",
    stroke: "#EDF2F7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7411 14.9824H14.2578",
    stroke: "#EDF2F7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.7656V16.2573",
    stroke: "#EDF2F7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.b2c3aeb4cdb2479056af995fa59813fc.svg";
export { ForwardRef as ReactComponent };